/**
 * Produkty proponowane domyślnie w dymkach asystenta doboru.
 *
 * To JEDYNE miejsce do edycji, gdy zmieniamy promowaną ofertę. Wartości to
 * identyfikatory OFERT (adres `/panel/<id>`, `/inwerter/<id>`, `/magazyn/<id>`),
 * a nie modeli — dymek pokazuje konkretną cenę u konkretnego sprzedawcy.
 *
 * ═══ DLACZEGO TO TYLKO PODPOWIEDŹ, A NIE TWARDY WYBÓR ═══
 *
 * `api/recommend.js` celowo NIE hardkodował identyfikatorów: różnią się między
 * środowiskami i po jednej z wcześniejszych zmian dymek zniknął na produkcji,
 * bo wskazany rekord istniał tylko lokalnie. Ta lekcja zostaje w mocy, dlatego
 * wskazany produkt jest PIERWSZYM KANDYDATEM, a nie jedyną odpowiedzią:
 *
 *   1. gdy identyfikatora nie da się pobrać (inne środowisko, wycofana oferta) —
 *      wracamy do dotychczasowego wyszukiwania i dymek pokazuje cokolwiek sensownego,
 *   2. gdy produkt NIE PASUJE do tego, o co pyta użytkownik (falownik innego typu
 *      lub mocy, magazyn poza zakresem pojemności) — też wracamy do wyszukiwania.
 *
 * Drugi punkt jest ważniejszy od pierwszego. Dymek stoi przy sekcji z filtrami
 * i ma proponować coś, co do tych filtrów pasuje. Falownik 8 kW pokazany komuś,
 * kto właśnie ustawił zakres 3–5 kW, nie jest propozycją, tylko reklamą — i to
 * taką, która podważa zaufanie do reszty doboru.
 *
 * Moduł nie ma filtrów w dymku (sekcja modułów pyta o moc instalacji, nie o model),
 * więc dla niego podpowiedź obowiązuje zawsze, o ile ofertę da się pobrać.
 */

export const PROPONOWANE_OFERTY = {
  // Trina Solar Vertex S+ TSM465-NEG9R.28 — 465 W
  panel: 6636,
  // Deye SUN-8K-SG05LP3-EU — hybrydowy, 8 kW
  inwerter: 10274,
  // DEYE SE-F5 PRO-C — 5,12 kWh, niskonapięciowy
  magazyn: 4209,
};

export default PROPONOWANE_OFERTY;
